import Modal from 'components/Luxkit/Modal/Modal'
import Heading from 'components/Luxkit/Typography/Heading'
import Group from 'components/utils/Group'
import React, { useMemo } from 'react'
import AccommodationRoomDetailsList from './AccommodationRoomDetailsList'
import { isHotelPackage } from 'lib/offer/offerTypes'
import AccommodationAmenitiesAndPoliciesContent
  from 'components/OfferPage/Accommodation/AccommodationAmenitiesAndPoliciesContent'

interface Props {
  roomPackage: App.HotelPackage | App.BedbankPackage
}

function AccommodationAmenitiesAndPoliciesModal(props: Props) {
  const { roomPackage } = props
  const packageName = useMemo<string>(() => {
    if (isHotelPackage(roomPackage)) {
      return roomPackage.roomType.name
    } else {
      return roomPackage.name
    }
  }, [roomPackage])

  return <Modal
    title="Room amenities & policies"
    subtitle={packageName}
  >
    <Group direction="vertical" gap={20}>
      <Group direction="vertical" gap={12}>
        <Heading variant="heading6">Room Details</Heading>
        <AccommodationRoomDetailsList roomPackage={roomPackage} />
      </Group>
      <AccommodationAmenitiesAndPoliciesContent roomPackage={roomPackage} />
    </Group>
  </Modal>
}

export default AccommodationAmenitiesAndPoliciesModal
